// extracted by mini-css-extract-plugin
module.exports = {"header":"InvalidGift_header__7d7S8","text":"InvalidGift_text__2MQVV","list":"InvalidGift_list__k86XB"};